import { createSelector } from '@reduxjs/toolkit';
import { Strategy } from 'client/voladeum/strategies/types';
import { RootState } from 'store';

const strategiesSlice = (state: RootState) => state.strategies;

export const selectStrategies = createSelector([strategiesSlice], (state): Strategy[] => state);
